<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-shop heroicon heroicon-sm"
  >
    <path
      class="heroicon-shop-wall heroicon-component-fill"
      fill="#FFFFFF"
      d="M7 5h46v54H7V5zm6 40v8h9v-8h-9zm5-34v9h4v-9h-4zm20 0v9h4v-9h-4zM28 45v10h4V45h-4zm10 0v8h9v-8h-9z"
    ></path>
    <path
      class="heroicon-shop-windows heroicon-component-fill"
      fill="#FFFFFF"
      d="M13 45h9v8h-9v-8zm5-34h4v9h-4v-9zm20 0h4v9h-4v-9zM28 45h4v10h-4V45zm10 0h9v8h-9v-8z"
    ></path>
    <rect
      class="heroicon-shop-cover-fill heroicon-component-fill"
      width="46"
      height="13"
      x="7"
      y="26"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-shop-cover-stripes heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M7 26h4v13H7V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26zm6 0h4v13h-4V26z"
    ></path>
    <path
      class="heroicon-shop-frames heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M10 42h15v14H10V42zm3 3v8h9v-8h-9zm2-37h10v15H15V8zm3 3v9h4v-9h-4zm17-3h10v15H35V8zm3 3v9h4v-9h-4zm-3 31h15v14H35V42zm3 3v8h9v-8h-9z"
    ></path>
    <path
      class="heroicon-shop-door heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M25 42h10v17H25V42zm3 3v10h4V45h-4z"
    ></path>
    <rect
      class="heroicon-shop-roof heroicon-component-accent heroicon-component-fill"
      width="50"
      height="4"
      x="5"
      y="1"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M7 39h46v5H7v-5zM7 5h46v2H7V5zm7 17h12v2H14v-2zm20 0h12v2H34v-2z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M4 6V0h52v6h-2v52h6v2H0v-2h6V6H4zm50-4H6v2h48V2zm-2 56V40h-2v18h2zm-3-16v-2H36v2h13zm-13 1v12h13V43H36zm13 13H36v2h13v-2zm0-20h-2v2h2v-2zm3 2v-2h-2v2h2zm0-3v-8h-2v8h2zm-5-8v8h2v-8h-2zm-1 0h-2v8h2v-8zm0 9h-2v2h2v-2zm-5-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8h-2zm0 9v2h2v-2h-2zm-3-9v8h2v-8H8zm0 9v2h2v-2H8zm3 22h13v-2H11v2zm-1-2V40H8v18h2v-2zm1-14h13v-2H11v2zm0 1v12h13V43H11zm23 15V43h-8v15h8zm0-16v-2h-8v2h8zm18-17V6H8v19h44zM38 44h10v10H37V44h1zm9 1h-9v8h9v-8zm-34-1h10v10H12V44h1zm9 1h-9v8h9v-8zm5-1h6v12h-6V44zm1 1v10h4V45h-4zm17-25h1v3H34v-3h1V8h10v12zM44 9h-8v11h1V10h6v10h1V9zm-6 7v4h4v-4h-4zm4-1v-4h-4v4h4zm-4 6h-3v1h10v-1h-7zM25 9v11h1v3H14v-3h1V8h10v1zm-9 0v11h1V10h6v10h1V9h-8zm6 2h-4v4h4v-4zm0 5h-4v4h4v-4zm-5 5h-2v1h10v-1h-8z"
    ></path>
  </svg>
</template>
